import { render, staticRenderFns } from "./UpdateWindow.vue?vue&type=template&id=2c4405bd&scoped=true"
import script from "./UpdateWindow.vue?vue&type=script&lang=js"
export * from "./UpdateWindow.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../../../../../../../opt/build-cache/ad/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c4405bd",
  null
  
)

export default component.exports